import React from "react";
import { useSearchParams } from "react-router-dom";

import * as Styled from "./styles";
import logo from "assets/images/inspecionarLogo.png";
import { CircularProgress } from "@mui/material";
import { DoNotDisturbAltOutlined } from "@mui/icons-material";
import { auth } from "modules/users-temp/services";
import { useAuthenticationConsumer } from "shared/providers/Authentication";

const Page = function (): React.ReactElement {
  const { signInUserTemp } = useAuthenticationConsumer();
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");

  const handleCheckToken = React.useCallback(async () => {
    const { status, data } = await auth(token);

    if ([200, 201].includes(status)) {
      signInUserTemp(data);
    }
  }, [signInUserTemp, token]);

  React.useEffect(() => {
    handleCheckToken();
  }, [handleCheckToken]);

  return (
    <Styled.Container>
      <img src={logo} width={295} alt="inspecionar-logo" />

      <Styled.Box>
        {!token ? (
          <Styled.NotAuth>
            <DoNotDisturbAltOutlined color="error" />
            &nbsp; Acesso não autorizado.
          </Styled.NotAuth>
        ) : (
          <Styled.NotAuth>
            <CircularProgress size={30} thickness={1} />
            &nbsp; Autorizando, aguarde...
          </Styled.NotAuth>
        )}
      </Styled.Box>
    </Styled.Container>
  );
};

export default Page;
